export const debugMode = useLocalStorage('debugMode', false)
